import { Form, Spinner } from "react-bootstrap";
import { useEffect, useState } from "react";

const BusCitySelection = ({
  code,
  name,
  setCity,
  closeCitySelection,
  orname,
  setDestination2,
  setDestination1,
}) => {
  const [searchInput, setSearchInput] = useState("");
  const [cities, setCities] = useState([]);
  const [loading, setLoading] = useState(false);
  const [staticBusCities, setStaticBusCities] = useState([]);
  const [topCities, setTopCities] = useState([]);

  useEffect(() => {
    const loadStaticCities = async () => {
      try {
        const response = await fetch(
          `${process.env.PUBLIC_URL || ""}/citiesData.js`,
          {
            cache: "no-store",
          }
        );
        const scriptText = await response.text();
        const transformed = scriptText
          .replace(/^[\s\S]*?export\s+const\s+busCities\s*=\s*/m, "return ")
          .replace(/;\s*$/, ";");
        const parser = new Function(transformed);
        const list = parser();
        if (Array.isArray(list)) {
          setStaticBusCities(list);
          const popular = [
            "Delhi",
            "Mumbai",
            "Bengaluru",
            "Bangalore",
            "Hyderabad",
            "Chennai",
            "Kolkata",
            "Pune",
            "Ahmedabad",
            "Jaipur",
            "Surat",
            "Lucknow",
          ];
          const picked = [];
          for (let name of popular) {
            const found = list.find((c) =>
              String(c.CityName || "")
                .toLowerCase()
                .startsWith(name.toLowerCase())
            );
            if (found && !picked.some((p) => p.CityId === found.CityId)) {
              picked.push(found);
            }
            if (picked.length >= 10) break;
          }
          setTopCities(picked);
          setCities(picked);
        }
      } catch (e) {
      } finally {
      }
    };
    loadStaticCities();
  }, []);

  const filterAndRankCities = (list, value) => {
    const v = (value || "").toLowerCase();
    if (!v) return [];
    return (list || [])
      .filter((user) => {
        return (
          user &&
          ((user.CityName && String(user.CityName).toLowerCase().includes(v)) ||
            (user.CityId &&
              String(user.CityId).toString().toLowerCase().includes(v)))
        );
      })
      .map((user) => {
        let priority = 2;
        if (user.CityName && String(user.CityName).toLowerCase().includes(v)) {
          priority = 1;
        } else if (
          user.CityId &&
          String(user.CityId).toString().toLowerCase().includes(v)
        ) {
          priority = 2;
        }
        return { ...user, priority };
      })
      .sort((a, b) => a.priority - b.priority);
  };

  //  const fetchDatas = (value) => {
  //   const payload = {
  //     city: value,
  //   };

  //   fetch("https://admin.travelsdata.com/api/Bus/City", {
  //     method: "POST",
  //     headers: {
  //       "Content-Type": "application/json",
  //     },
  //     body: JSON.stringify(payload),
  //   })
  //     .then((response) => response.json())
  //     .then((json) => {
  //       const results = json.data
  //         .filter((user) => {
  //           return (
  //             user &&
  //             ((user.CityName &&
  //               user.CityName.toLowerCase().includes(value.toLowerCase())) ||
  //               (user.CityId &&
  //                 user.CityId.toLowerCase().includes(value.toLowerCase())))
  //           );
  //         })
  //         .map((user) => {
  //           let priority = 3;

  //           if (
  //             user.CityName &&
  //             user.CityName.toLowerCase().includes(value.toLowerCase())
  //           ) {
  //             priority = 1;
  //           } else if (
  //             user.CityId &&
  //             user.CityId.toLowerCase().includes(value.toLowerCase())
  //           ) {
  //             priority = 2;
  //           }

  //           return { ...user, priority };
  //         })
  //         .sort((a, b) => a.priority - b.priority);

  //       setCities(results);
  //     })
  //     .catch((err) => {
  //       console.error("API fetch failed:", err);
  //     });
  // };

  const fetchDatas = (value) => {
    setLoading(true); // start loader
    const payload = { city: value };

    fetch("https://admin.travelsdata.com/api/Bus/City", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    })
      .then((response) => response.json())
      .then((json) => {
        const results = json.data
          .filter((user) => {
            return (
              user &&
              ((user.CityName &&
                user.CityName.toLowerCase().includes(value.toLowerCase())) ||
                (user.CityId &&
                  user.CityId.toLowerCase().includes(value.toLowerCase())))
            );
          })
          .map((user) => {
            let priority = 3;
            if (user.CityName?.toLowerCase().includes(value.toLowerCase())) {
              priority = 1;
            } else if (
              user.CityId?.toLowerCase().includes(value.toLowerCase())
            ) {
              priority = 2;
            }
            return { ...user, priority };
          })
          .sort((a, b) => a.priority - b.priority);

        setCities(results);
        setLoading(false); // stop loader
      })
      .catch((err) => {
        console.error("API fetch failed:", err);
        setLoading(false); // stop loader on error
      });
  };

  const handleInputChange = (event) => {
    const typed = event.target.value || "";
    const lower = typed.trim().toLowerCase();
    setSearchInput(typed);

    if (lower.length < 3) {
      setCities(topCities);
      setLoading(false);
      return;
    }

    const staticMatches = filterAndRankCities(staticBusCities, lower);
    if (staticMatches.length > 0) {
      setCities(staticMatches);
      setLoading(false);
      return;
    }

    fetchDatas(lower);
  };

  const handleValueFrom = (
    selectedValue,
    labelId,
    labelDepartureId,
    labelDepartId
  ) => {
    // Implement logic for handling selected value
  };

  const handleClearTextFromMul = (inputId) => {
    // Implement logic for clearing text from input
  };

  const handleOnSectorPressKeyV1 = (inputId) => {
    // Implement logic for handling key press on input
  };

  const handleOnSectorPressKeyV2 = (inputId, event) => {
    // Implement logic for handling key press on input with event
  };

  const handleCitySelection = (selected) => {
    const city = {
      code: selected?.CityId,
      name: selected?.CityName,
    };
    setCity(city);
    closeCitySelection();

    if (String(orname || "").toLowerCase() === "origin") {
      setDestination1(selected);
    } else {
      setDestination2(selected);
    }
  };

  const popularCities = [
    {
      code: "DEL",
      name: "New Delhi, India",
      airport: "Indira Gandhi Intl Airport",
    },
    {
      code: "BLR",
      name: "Bangalore, India",
      airport: "Kempegowda International Airport",
    },
    {
      code: "BOM",
      name: "Mumbai, India",
      airport: "Chhatrapati Shivaji Airport",
    },
    {
      code: "CCU",
      name: "Kolkata, India",
      airport: "Netaji S. Chandra Airport",
    },
    { code: "GOI", name: "Goa, India", airport: "Dabolim Airport" },
  ];

  return (
    <div className="bx_f2" id="divDepartauto" style={{}}>
      <div className="main_frm_f2" style={{ top: 0 }}>
        <div className="cntnt_f3_d">
          <div className="in_34">
            <div className="autosugst_newblock" style={{ left: "0" }}>
              <div className="fli-c-blv2">
                <div className="fli-m-bl">
                  <div className="fullblock_topcol">
                    <div
                      className="arrBackWhite"
                      id="backTosrch"
                      onClick={closeCitySelection}
                    ></div>
                    <div className="group input_autosugst autosHead">
                      Select {orname} City
                    </div>
                  </div>
                  <div>
                    <Form>
                      <a onClick={() => handleClearTextFromMul("mobFromhtml")}>
                        <input
                          type="text"
                          id="FromSector1Auto"
                          className="input_autosugst_New ac_input"
                          autoComplete="off"
                          onChange={handleInputChange}
                          placeholder="Enter your city name"
                        />
                      </a>
                      {/* <input
                        type="text"
                        id="FromSector1"
                        className="input_autosugst_New ac_input"
                        autoComplete="off"
                        onKeyDown={() => handleClearTextFromMul("mobFromhtml")}
                        onKeyUp={() => handleOnSectorPressKeyV1("FromSector1")}
                        placeholder="Enter city or airport name"
                        style={{ display: "none" }}
                      /> */}
                    </Form>
                  </div>
                </div>
              </div>
            </div>
            <div className="auto_saugg" id="auto_saugg">
              <div className="mn-atu-pg">
                <ul id="mobFromhtml">
                  {/* {popularCities.map((city) => (
                    <li
                      key={city.code}
                      onClick={() => handleCitySelection(city.code, city.name)}
                    >
                      <div className="dest-nm">
                        <span>{city.name}</span>
                        <span className="fnt-sz3"> {city.airport}</span>
                      </div>
                      <div className="dest-nm2">
                        <span>{city.code}</span>
                      </div>
                    </li>
                  ))} */}

                  {loading && (
                    <div
                      style={{
                        padding: "10px 5px",
                        fontSize: "12px",
                        textAlign: "center",
                        margin: "auto",
                        width: "100%",
                      }}
                    >
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />{" "}
                      Please wait we are fetching city list...
                    </div>
                  )}

                  {!loading &&
                    cities.map((city) => (
                      <li
                        key={city.CityName}
                        onClick={() => handleCitySelection(city)}
                        style={{ borderBottom: "0.3px solid #dfdfdf" }}
                      >
                        <div style={{ width: "100%" }} className="dest-nm">
                          <span className="city-itemBusMobile">
                            <img
                              className="icLocAlt icLocAltBusMobile"
                              src="https://www.easemytrip.com/images/auto-sugg-icon/place.png"
                              alt="icon"
                              style={{
                                width: "18px",
                                height: "18px",
                                marginRight: "5px",
                              }}
                            />
                            {city.CityName}
                          </span>
                        </div>
                      </li>
                    ))}

                  {/* {cities.map((city) => (
                    <li
                      key={city.CityName}
                      onClick={() => handleCitySelection(city.CityId, city.CityName, city)}

                    >
                      <div className="dest-nm">
                        <span><img
            className="icLocAlt appendRight8-bookings_form icLocAltBusMobile"
            src="/Images/location.png"
            alt="icon"
          />{`${city.CityName}`}</span>
                      </div>
                      <div className="dest-nm2">
                      </div>
                    </li>
                  ))} */}
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="clr"></div>
      </div>
      <div className="blc_brd3"></div>
      <div className="clr"></div>
    </div>
  );
};

export default BusCitySelection;
